import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { MenuService } from '../../../@core/services/menu.service';
import { SidebarService } from '../../../@core/sidebar/sidebar.service';
import { LayoutService } from '../../service/app.layout.service';

@Component({
  selector: 'app-config-widget',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DrawerModule,
    ButtonModule,
    // InputGroup,
    TranslatePipe,
    InputGroupAddonModule,
    ToggleSwitch
  ],
  templateUrl: './app-config-widget.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppConfigWidgetComponent {

  @ViewChild('themeSwitcher', { static: false })
  themeSwitcher: ElementRef<HTMLElement>;

  scales: number[] = [13, 14, 15, 16, 17];

  constructor(
    public layoutService: LayoutService,
    public menuService: MenuService,
    public sidebarService: SidebarService
  ) { }

  get darkMode(): boolean {
    return this.layoutService.config().colorScheme == "dark";
  }
  set darkMode(_val: boolean) {
    this.layoutService.config.update((config) => ({
      ...config,
      colorScheme: _val ? "dark" : "light",
    }));
  }

  get sidebarDark(): boolean {
    return this.sidebarService.forceDarkSidebarSig();
  }
  set sidebarDark(_val: boolean) {
    this.sidebarService.setForceDarkSidebar(_val);
  }

  get scale(): number {
    return this.layoutService.config().scale;
  }
  set scale(_val: number) {
    this.layoutService.config.update((config) => ({
      ...config,
      scale: _val,
    }));
  }

  get inputStyle(): string {
    return this.layoutService.config().inputStyle;
  }
  set inputStyle(_val: string) {
    this.layoutService.config().inputStyle = _val;
  }

  get ripple(): boolean {
    return this.layoutService.config().ripple;
  }
  set ripple(_val: boolean) {
    this.layoutService.config.update((config) => ({
      ...config,
      ripple: _val,
    }));
  }

  //...

  decrementScale() {
    this.scale--;
  }

  incrementScale() {
    this.scale++;
  }

}
